import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, errMsg } from "@/components/email/EmParts";

const FIELDS = [["logo_url", "Logo image URL (upload in the builder's Images tab, then paste)"], ["website_url", "Website URL"], ["font_family", "Font (e.g. Arial, Georgia, Helvetica)"], ["facebook", "Facebook URL"], ["instagram", "Instagram URL"], ["youtube", "YouTube URL"], ["tiktok", "TikTok URL"], ["footer_text", "Standard footer text"], ["default_sender_name", "Default sender name"], ["default_sender_email", "Default sender email"]];
const COLORS = [["primary_color", "Primary"], ["accent_color", "Buttons & links"], ["text_color", "Text"], ["background_color", "Background"]];

export default function BrandForm({ manage }) {
  const [b, setB] = useState(null);
  useEffect(() => { api.get("/email-marketing/brand").then((r) => setB(r.data)).catch(() => {}); }, []);
  if (!b) return null;
  const set = (k) => (e) => setB({ ...b, [k]: e.target.value });
  const save = async () => { try { const { updated_at, updated_by, ...body } = b; const { data } = await api.put("/email-marketing/brand", body); setB(data); toast.success("Brand settings saved"); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Card title="Brand settings for email templates" testId="em-brand-form">
      <p className="text-xs text-slate-500 mb-3">New templates start with these settings automatically.</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {FIELDS.map(([k, l]) => <Input key={k} value={b[k] || ""} onChange={set(k)} placeholder={l} disabled={!manage} data-testid={`em-brand-${k}`} />)}
      </div>
      <div className="flex flex-wrap gap-4 mt-3">{COLORS.map(([k, l]) => (
        <label key={k} className="flex items-center gap-2 text-xs text-slate-600"><input type="color" value={b[k] || "#000000"} onChange={set(k)} disabled={!manage} data-testid={`em-brand-${k}`} />{l}</label>))}</div>
      {b.logo_url && <img src={b.logo_url} alt="Logo" className="h-12 mt-3 object-contain" data-testid="em-brand-logo-preview" />}
      {manage && <Button variant="outline" className="mt-3" onClick={save} data-testid="em-brand-save">Save brand settings</Button>}
    </Card>
  );
}
